import React from 'react';
import { TextWrapper, Wrapper } from './SQLForm.Styles';
import { FreeForm } from './FreeForm';
export var SQLForm = function (_a) {
    var formValues = _a.formValues, setFieldValue = _a.setFieldValue;
    return (React.createElement(Wrapper, null,
        React.createElement(TextWrapper, null,
            React.createElement(FreeForm, { values: formValues, setFieldValue: setFieldValue }))));
};
SQLForm.defaultProps = {};
//# sourceMappingURL=SQLForm.js.map